export const holidayKey = ['valentines', 'easter', 'halloween', 'thanksgiving', 'christmas'] as const
export type HolidayKey = (typeof holidayKey)[number]

interface DateDetails {
    month: number
    day: number
}

interface Dates {
    start: DateDetails
    end: DateDetails
}

interface HolidayDetails {
    name: HolidayKey
    dates: Dates
    extendsToNewYear?: boolean
}

export class HolidayDateUtils {
    static readonly holidayDates: HolidayDetails[] = [
        {
            name: 'valentines',
            dates: {
                start: {
                    month: 1,
                    day: 24,
                },
                end: {
                    month: 2,
                    day: 18,
                },
            },
        },
        {
            name: 'easter',
            dates: {
                start: {
                    month: 3,
                    day: 20,
                },
                end: {
                    month: 4,
                    day: 30,
                },
            },
        },
        /* {
            name: 'mothersDay',
            dates: {
                start: {
                    month: 5,
                    day: 1,
                },
                end: {
                    month: 5,
                    day: 20,
                },
            },
        },
        {
            name: 'fathersDay',
            dates: {
                start: {
                    month: 6,
                    day: 1,
                },
                end: {
                    month: 6,
                    day: 25,
                },
            },
        }, */
        {
            name: 'halloween',
            dates: {
                start: {
                    month: 10,
                    day: 10,
                },
                end: {
                    month: 11,
                    day: 5,
                },
            },
        },
        {
            name: 'thanksgiving',
            dates: {
                start: {
                    month: 11,
                    day: 6,
                },
                end: {
                    month: 11,
                    day: 30,
                },
            },
        },
        {
            name: 'christmas',
            dates: {
                start: {
                    month: 12,
                    day: 1,
                },
                end: {
                    month: 1,
                    day: 12,
                },
            },
            extendsToNewYear: true,
        },
    ]

    static isHolidayNowAndExtendsToNewYear(holidayDate: HolidayDetails, now: Date, start: Date, end: Date): boolean {
        if(!holidayDate.extendsToNewYear) return false
        if(now >= start) return true
        if(now <= end) return true
        return false
    }

    static isHolidayNow(now: Date, start: Date, end: Date): boolean {
        let isAfterOrEqualToStartDate = false
        let isBeforeOrEqualToEndDate = false
        if(now >= start) isAfterOrEqualToStartDate = true
        if(now <= end) isBeforeOrEqualToEndDate = true
        if(isAfterOrEqualToStartDate && isBeforeOrEqualToEndDate) return true
        return false
    }

    static getCurrentHoliday(date?: Date): HolidayKey | undefined {
        const now = date ?? new Date()

        for(const holidayDate of HolidayDateUtils.holidayDates) {
            const start = new Date(now)
            start.setMonth(holidayDate.dates.start.month - 1)
            start.setDate(holidayDate.dates.start.day)

            const end = new Date(now)
            end.setMonth(holidayDate.dates.end.month - 1)
            end.setDate(holidayDate.dates.end.day)

            if(HolidayDateUtils.isHolidayNowAndExtendsToNewYear(holidayDate, now, start, end)) return holidayDate.name
            if(HolidayDateUtils.isHolidayNow(now, start, end)) return holidayDate.name
        }

        return undefined
    }
}
